"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TestId = void 0;
let TestId = exports.TestId = /*#__PURE__*/ function(TestId) {
    // Close notification button
    TestId["CloseNotificationButton"] = "close-notification-button";
    // Alert wrapper for notification message
    TestId["NotificationMessage"] = "notification-message";
    // Link inside notification message alert
    TestId["NotificationMessageLink"] = "notification-message-link";
    return TestId;
}({});
